import {
  IAppInfoResponse,
  IBalanceSheetResponse,
  IDebtorListResponse,
  IEntitiesResponse,
  IReceivableListResponse,
  ITermsResponse,
} from '../../interfaces/services';
import {IDocumentListResponse} from '../../interfaces/services/document-list.interface';
import {INotificationListResponse} from '../../interfaces/services/notification-list-response.interface';
import {IResponse} from '../../interfaces/services/response.interface';
import {ISemaphoreResponse} from '../../interfaces/services/semaphore-response.interface';
import {IStandardServiceResponse} from '../../interfaces/services/standard-service.interface';
import {
  processFatalError,
  processResponseFailed,
  RemoteCallError,
} from '../exceptions';

export const remoteCall = async function (
  call: () => Promise<Response>,
  process: (response: Response) => Promise<any>,
  reference?: string,
): Promise<
  | IAppInfoResponse
  | IBalanceSheetResponse
  | IStandardServiceResponse
  | IDocumentListResponse
  | INotificationListResponse
  | ISemaphoreResponse
  | IDebtorListResponse
  | IReceivableListResponse
  | IResponse
  | ITermsResponse
  | IEntitiesResponse
> {
  let messageError: string | undefined;
  try {
    const response = await call();
    const result = await process(response);
    if (result == null) {
      console.debug('processResponseFailed messageError: ', reference);
      messageError = await processResponseFailed(response, reference);
    } else if (
      result.success === false ||
      (result.payload && result.payload.success === false)
    ) {
      await processResponseFailed(response, reference);
    }
    return result;
  } catch (ex) {
    messageError = processFatalError(ex as Error, reference);
  }
  throw new RemoteCallError(messageError);
};

export const customFetch = async (
  url: string,
  options?: RequestInit,
): Promise<any> => {
  console.debug('Fetching:', url); // Log de la petición

  try {
    return fetch(url, options);
  } catch (error) {
    console.error('Error fetching data:', error);
    throw error;
  }
};
